import type { LineSolo } from "../../domain/lines";

interface Props {
  lineSolo: LineSolo;
  onChange: (solo: LineSolo) => void;
  /** The sweep-only solo exists only while the feature engine is the audible one. */
  sweepAvailable: boolean;
}

const OPTIONS: Array<{ id: LineSolo; label: string; title?: string }> = [
  { id: "all", label: "All" },
  { id: "continuum", label: "Continuum" },
  { id: "sweep", label: "Sweep", title: "Mute the drones and pad; hear only the feature-sweep plucks" },
  { id: "Halpha", label: "Hα" },
  { id: "Hbeta", label: "Hβ" },
  { id: "Hgamma", label: "Hγ" },
  { id: "OIII", label: "[O III]" },
];

export function SoloSection({ lineSolo, onChange, sweepAvailable }: Props) {
  return (
    <div className="panel-section">
      <h2>Line solo</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        {OPTIONS.filter((o) => o.id !== "sweep" || sweepAvailable).map((option) => (
          <button
            key={option.id}
            className={lineSolo === option.id ? "active" : ""}
            onClick={() => onChange(option.id)}
            title={option.title}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
